import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../../Univ.js'

function VitalSign(props){

  const {ip_id} = useParams();
  const [ipData, setIpData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [vitalData, setVitalData] = useState([]);
  const [nurseData,setnurseData]=useState({
        "ip":'',
        "tempr":'',
        "pulse":'',
        "resp":'',
        "bps":'',
        "bpd":'',
        "spo2":'',
        "vital_time":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
   const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };

   useEffect(() => {
        fetchvitalData();
   }, []);
    function fetchvitalData() {
      axios.get(baseUrl + "view-vital/" + ip_id + "/")
        .then(response => {
          setVitalData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }

  const formSubmit = (e) => {
      e.preventDefault();
         const tempr = document.getElementById("tempr").value;
         const pulse = document.getElementById("pulse").value;
         const resp = document.getElementById("resp").value;
         const bps = document.getElementById("bps").value;
         const bpd = document.getElementById("bpd").value;
         const spo2 = document.getElementById("spo2").value;
         const vital_time = document.getElementById("vital_time").value;
          const _formData = new FormData();
          _formData.append('ip', ip_id);
          _formData.append('tempr', tempr);
          _formData.append('pulse', pulse);
          _formData.append('resp', resp);
          _formData.append('bps', bps);
          _formData.append('bpd', bpd);
          _formData.append('spo2', spo2);
          _formData.append('vital_time', vital_time);
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}vital-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Vital Signs Succesfully',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setnurseData({
                  ip: '',
                  notes: '',
                  vital_time: '',
                  status: '',
                  addedby: '',
                  ip_add: '',
                });
                setTimeout(() => {
                  window.location.href = '/nurse-pat-view/'+ ip_id +'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed. Please try again later.',
                'error'
              );
            });
  };
  const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-vital/'+id+'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                    window.location.href = ('/vital-sign/'+ip_id+'/');
                    }, 3000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }

    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{ color: 'red' }}></i>
      Primary Consultant -  Dr.{ipData.map(row => row.primary_consult.consultant)}
    </h3>
     <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip_id}</td>
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{formatDateTime(patientData.admit_date)}</td>
          </tr>
        ))}
      </tbody>
        </table>
     </div>
  <div >
  <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-bed-pulse" aria-hidden="true" style={{ color: 'red' }}></i>
      Vital Signs
    </h3>
      <form>
      <div className="row">
        <div className="col-md-2">
          <label htmlFor="Tempr" className="form-label">Temperature(in F) : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="tempr"
            id="tempr"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="" className="form-label">Pulse (Beat/Min)</label>
          <input
            type="number"
            className="ms-1 form-control"
            name="pulse"
            id="pulse"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Respiration (Breath/Min) : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="resp"
            id="resp"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">BP Systolic : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="bps"
            id="bps"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">BP Diastolic : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="bpd"
            id="bpd"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">SPO2 : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="spo2"
            id="spo2"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Notes Time" className="form-label">Notes Time : </label>
          <DatePicker className="form-control" name="vital_time" id="vital_time" selected={selectedDateTime}
                            onChange={handleDateTimeChange}
                            dateFormat="yyyy-MM-dd h:mm"
                            showTimeSelect
                            timeIntervals={15}
                            timeCaption="Time"
                        />
        </div>
       </div>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
          <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
        </div>
      </form>
              <div className="card card-body">
              <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa-solid fa-bed-pulse" aria-hidden="true" style={{ color: 'red' }}></i>
                  Vital Signs History
                    </h3>
               <div className="table-responsive">
              <table className="erp-table-modern">
              <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                      <th>Date</th>
                      <th colSpan="5">Vital Sign Details</th>
                      <th>Delete</th>
                    </tr>
              </thead>
              <tbody>
                {vitalData.map((dis, index) => (
                      <tr >
                        <td>{formatDateTime(dis.vital_time)}</td>
                        <td>Tempr: {dis.tempr}</td>
                        <td>Pulse: {dis.pulse}</td>
                        <td>Respiration: {dis.resp}</td>
                        <td>Bp Systolic/Diastolic: {dis.bps}/{dis.bpd}</td>
                        <td>SPO2: {dis.spo2}</td>
                        <td>
                          <button className="btn btn-danger" type="button" onClick={() => handleDelete(dis.id)}>
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
                </table>
                </div>
              </div>
    </div>
    </section>
    )
}

export default VitalSign;